import { Add, Edit, InfoOutlined, KeyboardArrowDown } from '@mui/icons-material';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Checkbox,
    Chip,
    CircularProgress,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    MenuItem,
    Select,
    Stack,
    Switch,
    TextField,
    Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { REQUIRED_RED } from '../../../../App';
import { MuiSelectWithFocus } from '../../../../config/MaterialUIConstants';
import { SHOP_CREATED, SHOP_IMPORTED, USER_TYPES } from '../../../../config/dataService/constants';
import { useGetMechanicDetails } from '../../../../services/core/master/master.hooks';
import { CHIP_COLOR } from '../../../../utility/Constant';
import CalendarPickerSvg from '../../../../utility/Svg/CalendarPickerSvg';
import FleetIconSvg from '../../../../utility/Svg/FleetIconSvg';
import CustomerFleet from '../../../../utility/Svg/CustomerFleet';
import CustomerTrim from '../../../../utility/Svg/CustomerTrim';
import CustomerVin from '../../../../utility/Svg/CustomerVin';
import { CustomTooltip, PhoneTypeIcon } from '../../../../utility/helpers/commonFunction';
import { inputFormatPhoneNumber } from '../../../Common/FormatPhoneNumber';
import CustomDateTimePicker from './CustomDateTimePicker';

const AppointmentDetailsAccordion = ({
    control,
    errors,
    setValue,
    clearErrors,
    setError,
    getValues,
    // State props
    customerDetails,
    customerData,
    setCustomerData,
    customerListLoader,
    customerTypeData,
    setCustomerTypeData,
    state,
    setState,
    handleCheckChange,
    handleInputDebounced,
    handleBlur,
    handleScroll,
    servicePageData,
    page,
    setPage,
    customerList,
    limits,
    customerCreatedFrom,
    setCustomerCreatedFrom,
    handleOpenCustomerInfo,
    openAddCustomerModal,
    setOpenAddCustomerModal,
    skipConfirmation,
    setSkipConfirmation,
    // Vehicle props
    vehicleList,
    vehicleData,
    setVehicleData,
    vehicleLoader,
    // setVehicleSourceData,

    // handleVehicleInfoOpen,
    handleVehicleOpen,
    openVehicleModal,
    setOpenVehicleModal,
    editVehicleData,
    setEditVehicleData,
    // Date props
    dropOffDate,
    setDropOffDate,
    pickUpDate,
    setPickUpDate,
    getShopClosingTime,
    isFirstSelection,
    setIsFirstSelection,
    getClosestAllowedMinute,
    disablePrevDates,
    // Other props
    customerOnSite,
    setCustomerOnSite,
    setIsEditCustomer,
    id,
    type,
    isOpenSideBar,
    shopConfigData,
    triggerOpenDatePicker,
    datePickerWasUsedRef,
    shopId,
}) => {
    const [accordionExpanded, setAccordionExpanded] = useState(true);
    const [dropOffPickerOpen, setDropOffPickerOpen] = useState(false);
    const [pickUpPickerOpen, setPickUpPickerOpen] = useState(false);
    const [vehicleDropdownOpen, setVehicleDropdownOpen] = useState(false);

    // Open date picker when triggered from parent (e.g., from business hours dialog)
    useEffect(() => {
        if (triggerOpenDatePicker > 0) {
            setDropOffPickerOpen(true);
        }
    }, [triggerOpenDatePicker]);

    // Use TanStack Query for mechanic details
    const { data: mechanicDetailsData, isLoading: mechanicDetailsLoading, error: mechanicDetailsError } = useGetMechanicDetails();

    const mechanicList = mechanicDetailsData || [];

    // Set default mechanic in form when data loads
    useEffect(() => {
        if (mechanicList?.length > 0 && !id) {
            const currentValue = getValues('assignee');
            // Only set default if no value is currently set
            if (!currentValue) {
                let defaultMechanicId = null;
                if (mechanicList.length === 1) {
                    defaultMechanicId = mechanicList[0]?._id;
                } else {
                    const defaultMechanic = mechanicList.find((d) => d.isDefault === true);
                    if (defaultMechanic) {
                        defaultMechanicId = defaultMechanic._id;
                    }
                }
                if (defaultMechanicId) {
                    setValue('assignee', defaultMechanicId);
                }
            }
        }
    }, [mechanicList, id, setValue, getValues]);

    // set customer detail
    // useEffect(() => {
    //     if (customerDetailData && isEditCustomer) {
    //         setValue('firstName', customerDetailData?.firstName);
    //         setValue('lastName', customerDetailData?.lastName);
    //         setValue('email', customerDetailData?.email);
    //         // set other fields
    //     }
    // }, [customerDetailData, isEditCustomer]);

    const handleAccordionToggle = () => {
        setAccordionExpanded(!accordionExpanded);
    };

    return (
        <Grid item xs={12}>
            <Accordion
                expanded={accordionExpanded}
                style={{
                    boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.10)',
                    borderRadius: '8px',
                    background: '#fff',
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <IconButton style={{ background: '#334FA9', padding: '0', width: '30px', height: '30px' }}>
                            <KeyboardArrowDown sx={{ color: '#fff', fontSize: '26px' }} />
                        </IconButton>
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordianSummaryPadding"
                    style={{
                        minHeight: '80px',
                    }}
                    onClick={handleAccordionToggle}
                >
                    <div className="accordianTitleWrapper">
                        <Box sx={{ mr: 0, display: 'flex', alignItems: 'center' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M18.5349 3.65459H14.6336C14.2416 2.57896 13.2149 1.80005 12.0016 1.80005C10.7882 1.80005 9.76156 2.57896 9.36956 3.65459H5.46823C4.44156 3.65459 3.60156 4.48914 3.60156 5.50914V20.3455C3.60156 21.3655 4.44156 22.2001 5.46823 22.2001H18.5349C19.5616 22.2001 20.4016 21.3655 20.4016 20.3455V5.50914C20.4016 4.48914 19.5616 3.65459 18.5349 3.65459ZM12.0016 3.65459C12.5149 3.65459 12.9349 4.07187 12.9349 4.58187C12.9349 5.09187 12.5149 5.50914 12.0016 5.50914C11.4882 5.50914 11.0682 5.09187 11.0682 4.58187C11.0682 4.07187 11.4882 3.65459 12.0016 3.65459ZM18.5349 20.3455H5.46823V5.50914H7.3349V8.29096H16.6682V5.50914H18.5349V20.3455Z"
                                    fill="#006CDD"
                                />
                            </svg>
                        </Box>
                        <Typography className="accordianTitle">Appointment Details</Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails className="accordianDetailsWrapper">
                    <Grid container spacing={3}>
                        {/* Customer field */}
                        <Grid item xs={12}>
                            <FormControl fullWidth required error={!!errors.customer}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '8px',
                                    }}
                                >
                                    <Typography variant="body1" className="formLabelTitle">
                                        Customer <span style={{ color: REQUIRED_RED }}>*</span>
                                    </Typography>

                                    {customerCreatedFrom == 'shop_imported' ? (
                                        <Grid>
                                            <Typography
                                                color={'secondary'}
                                                fontWeight={500}
                                                fontSize="15px"
                                                onClick={() => {
                                                    setIsEditCustomer(true);
                                                    setOpenAddCustomerModal(true);
                                                }}
                                                sx={{ cursor: 'pointer' }}
                                            >
                                                {' '}
                                                + Add Customer Info
                                            </Typography>
                                        </Grid>
                                    ) : (
                                        <Grid item display="flex" alignItems="center" gap={0}>
                                            {customerData?.createdFrom === SHOP_CREATED && customerData?._id && (
                                                <>
                                                    <Stack
                                                        direction="row"
                                                        alignItems="center"
                                                        spacing={0}
                                                        onClick={() => {
                                                            setIsEditCustomer(true);
                                                            setOpenAddCustomerModal(true);
                                                        }}
                                                    >
                                                        <Edit color="secondary" sx={{ width: '16px', height: '16px', mr: '6px', cursor: 'pointer' }} />

                                                        <Typography
                                                            color={'secondary'}
                                                            fontWeight={500}
                                                            fontSize={'15px'}
                                                            sx={{ cursor: 'pointer' }}
                                                            // onClick={() => {
                                                            //     setOpenAddCustomerModal(true);
                                                            //     setIsEditCustomer(true);
                                                            // }}
                                                            // sx={{ cursor: 'pointer' }}
                                                        >
                                                            Edit
                                                        </Typography>
                                                    </Stack>

                                                    {!id && (
                                                        <Divider
                                                            orientation="vertical"
                                                            variant="middle"
                                                            flexItem
                                                            sx={{ mx: 1, height: '20px', pointerEvents: 'none' }}
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {!id && (
                                                <Stack
                                                    direction={'row'}
                                                    alignItems={'center'}
                                                    sx={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setIsEditCustomer(false);
                                                        setOpenAddCustomerModal(true);
                                                    }}
                                                >
                                                    <Add color="secondary" sx={{ mr: '2px' }} />
                                                    <Typography
                                                        color="secondary"
                                                        fontWeight={500}
                                                        fontSize="15px"
                                                        sx={{ cursor: 'pointer' }}
                                                        // onClick={() => {
                                                        //     setOpenAddCustomerModal(true);
                                                        //     setIsEditCustomer(false);
                                                        // }}
                                                    >
                                                        New
                                                    </Typography>
                                                </Stack>
                                            )}

                                            <Switch
                                                size="small"
                                                color="primary"
                                                checked={skipConfirmation}
                                                onChange={(e) => setSkipConfirmation(e.target.checked)}
                                                sx={{
                                                    width: '40px',
                                                    marginLeft: '6px',
                                                    '& .MuiSwitch-thumb': {
                                                        width: 16,
                                                        height: 16,
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                        transform: 'translateX(16px)',
                                                    },
                                                    '& .MuiSwitch-track': {
                                                        borderRadius: 20 / 2,
                                                    },
                                                }}
                                            />

                                            <CustomTooltip
                                                width="280px"
                                                placement="top"
                                                title={
                                                    <Typography fontSize="14px" fontWeight={400} align="center" letterSpacing="-0.42px" lineHeight="140%">
                                                        {/* Skip sending the appointment confirmation text message and email to the customer */}
                                                        Skip sending “Appointment Confirmed” text and email
                                                    </Typography>
                                                }
                                            >
                                                <InfoOutlined sx={{ fontSize: '24px', color: '#8C8C8C', cursor: 'pointer' }} />
                                            </CustomTooltip>
                                        </Grid>
                                    )}
                                </div>

                                <Controller
                                    name="customer"
                                    control={control}
                                    rules={{ required: 'Customer is required' }}
                                    render={({ field: { onChange, value, name, ref } }) => (
                                        <Autocomplete
                                            name={name}
                                            ref={ref}
                                            disablePortal
                                            id="combo-box-demo"
                                            options={customerDetails ? customerDetails : []}
                                            getOptionLabel={(option) => option?.fullName || ''}
                                            forcePopupIcon
                                            clearIcon={null}
                                            onClose={() => {
                                                const isCustomer = getValues()?.customer;
                                                if (!isCustomer) {
                                                    setPage(1);
                                                    customerList(1, limits, null);
                                                }
                                            }}
                                            loading={customerListLoader}
                                            disabled={id || customerTypeData.length == 0}
                                            isOptionEqualToValue={(option, value) => {
                                                if (!option || !value) return false;
                                                return option._id === value._id || option.refIdUsers === value.refIdUsers;
                                            }}
                                            value={customerData || value || null}
                                            onChange={(event, newValue) => {
                                                onChange(newValue);
                                                setCustomerData(newValue);
                                                setVehicleData(null);
                                                setValue('vehicle', null);
                                                if (newValue) {
                                                    setCustomerCreatedFrom(newValue?.createdFrom);
                                                    clearErrors('customer');
                                                }
                                            }}
                                            loadingText={
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <CircularProgress />
                                                </div>
                                            }
                                            renderInput={(params) => {
                                                const endAdornment = params.InputProps.endAdornment;
                                                const clearIcon = endAdornment?.props?.children?.[0] || null;
                                                const dropdownIcon = endAdornment?.props?.children?.[1] || null;

                                                return (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        variant="outlined"
                                                        error={!!errors.customer}
                                                        helperText=""
                                                        FormHelperTextProps={{ style: { display: 'none' } }}
                                                        onChange={(e) => handleInputDebounced(e, e.target.value)}
                                                        onBlur={handleBlur}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '6px',
                                                                    }}
                                                                >
                                                                    {clearIcon && (
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                mr: '2px',
                                                                            }}
                                                                        >
                                                                            {clearIcon}
                                                                        </Box>
                                                                    )}

                                                                    {(customerData?.isFleetCustomer || customerData?.shopCustomer?.isFleetCustomer) && (
                                                                        <FleetIconSvg width="42px" height="30px" />
                                                                    )}

                                                                    {dropdownIcon && <Box sx={{ display: 'flex', alignItems: 'center' }}>{dropdownIcon}</Box>}
                                                                </Box>
                                                            ),
                                                        }}
                                                    />
                                                );
                                            }}
                                            ListboxProps={{
                                                style: { maxHeight: '300px' },
                                                onScroll: (event) => {
                                                    handleScroll(event);
                                                },
                                            }}
                                            renderOption={(props, option) => {
                                                const optionIndex = props['data-option-index'];
                                                const isLastItem = optionIndex === customerDetails.length - 1;

                                                return (
                                                    <>
                                                        <Box component="li" {...props} style={{ padding: '0' }}>
                                                            <li
                                                                {...props}
                                                                style={{
                                                                    width: '100%',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    padding: '16px',
                                                                }}
                                                                key={option?._id}
                                                                onClick={() => {
                                                                    if (option.createdFrom == 'shop_imported') {
                                                                        setCustomerData(option);
                                                                        setIsEditCustomer(true);
                                                                        setOpenAddCustomerModal(true);
                                                                    }
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        gap: '6px',
                                                                        flex: 1,
                                                                        minWidth: 0,
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        fontWeight={600}
                                                                        fontSize={16}
                                                                        sx={{
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                        }}
                                                                    >
                                                                        {option.fullName}
                                                                    </Typography>

                                                                    <Typography
                                                                        fontSize={14}
                                                                        fontWeight={400}
                                                                        letterSpacing={'0.15px'}
                                                                        lineHeight={'150%'}
                                                                        sx={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px',
                                                                        }}
                                                                    >
                                                                        {PhoneTypeIcon(option?.primaryPhoneNumberType || 'mobile')}
                                                                        {option.phoneNumber ? inputFormatPhoneNumber(option.phoneNumber) : ''}
                                                                    </Typography>

                                                                    {option.company && (
                                                                        <Typography
                                                                            fontSize={14}
                                                                            fontWeight={400}
                                                                            letterSpacing={'0.15px'}
                                                                            lineHeight={'150%'}
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '6px',
                                                                            }}
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="20"
                                                                                height="21"
                                                                                viewBox="0 0 20 21"
                                                                                fill="none"
                                                                            >
                                                                                <path
                                                                                    d="M3.33268 18.0001C2.87435 18.0001 2.48213 17.837 2.15602 17.5109C1.8299 17.1848 1.66657 16.7923 1.66602 16.3334V7.16675C1.66602 6.70841 1.82935 6.31619 2.15602 5.99008C2.48268 5.66397 2.8749 5.50064 3.33268 5.50008H6.66602V3.83341C6.66602 3.37508 6.82935 2.98286 7.15602 2.65675C7.48268 2.33064 7.8749 2.1673 8.33268 2.16675H11.666C12.1243 2.16675 12.5168 2.33008 12.8435 2.65675C13.1702 2.98341 13.3332 3.37564 13.3327 3.83341V5.50008H16.666C17.1243 5.50008 17.5168 5.66341 17.8435 5.99008C18.1702 6.31675 18.3332 6.70897 18.3327 7.16675V16.3334C18.3327 16.7917 18.1696 17.1842 17.8435 17.5109C17.5174 17.8376 17.1249 18.0006 16.666 18.0001H3.33268ZM8.33268 5.50008H11.666V3.83341H8.33268V5.50008Z"
                                                                                    fill="#006CDD"
                                                                                />
                                                                            </svg>
                                                                            {option.company}
                                                                        </Typography>
                                                                    )}
                                                                </Box>

                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'flex-end',
                                                                        gap: '12px',
                                                                        pl: 2,
                                                                    }}
                                                                >
                                                                    {(option?.isFleetCustomer || option?.shopCustomer?.isFleetCustomer) && (
                                                                        <FleetIconSvg height="30px" width="42px" />
                                                                    )}
                                                                    <Chip
                                                                        label={
                                                                            option.createdFrom === SHOP_CREATED
                                                                                ? 'Shop Created'
                                                                                : option.createdFrom === SHOP_IMPORTED
                                                                                  ? 'Shop Imported'
                                                                                  : 'Apex Auto'
                                                                        }
                                                                        sx={{
                                                                            borderRadius: '100px',
                                                                            fontSize: '13px',
                                                                            fontWeight: 500,
                                                                            lineHeight: '18px',
                                                                            height: '30px',
                                                                            px: '8px',
                                                                            backgroundColor:
                                                                                option.createdFrom === SHOP_CREATED
                                                                                    ? CHIP_COLOR.SHOP_CREATED_BG
                                                                                    : option.createdFrom === SHOP_IMPORTED
                                                                                      ? CHIP_COLOR.SHOP_IMPORTED_BG
                                                                                      : CHIP_COLOR.APEX_AUTO_APP_BG,
                                                                            color:
                                                                                option.createdFrom === SHOP_CREATED
                                                                                    ? CHIP_COLOR.SHOP_CREATED_COLOR
                                                                                    : option.createdFrom === SHOP_IMPORTED
                                                                                      ? CHIP_COLOR.SHOP_IMPORTED_COLOR
                                                                                      : CHIP_COLOR.APEX_AUTO_APP_COLOR,
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </li>
                                                        </Box>

                                                        {/* Show loader at the end of the list when loading more */}
                                                        {customerListLoader && isLastItem && (
                                                            <Box component="li" style={{ padding: 0 }}>
                                                                <li
                                                                    style={{
                                                                        width: '100%',
                                                                        justifyContent: 'center',
                                                                        display: 'flex',
                                                                        padding: '16px',
                                                                    }}
                                                                >
                                                                    <CircularProgress size={24} />
                                                                </li>
                                                            </Box>
                                                        )}
                                                    </>
                                                );
                                            }}
                                            sx={{
                                                height: '50px',
                                                boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                borderRadius: '8px',
                                                '& .MuiInputBase-root': {
                                                    padding: '0 0 0 12px',
                                                    border: 'none',
                                                    height: '50px',
                                                },
                                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                    borderRadius: '8px',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    paddingRight: '6px!important',
                                                },
                                            }}
                                        />
                                    )}
                                />
                                {errors.customer && (
                                    <FormHelperText error sx={{ mt: 0.5, mb: 0 }}>
                                        {errors.customer.message}
                                    </FormHelperText>
                                )}
                                <Stack direction={'row'} gap={0} flexWrap={'wrap'}>
                                    <FormControlLabel
                                        control={<Checkbox checked={state.shop_created} onChange={handleCheckChange} name="shop_created" disabled={id} />}
                                        labelPlacement="end"
                                        label="Shop Created"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={state.shop_imported} onChange={handleCheckChange} name="shop_imported" disabled={id} />}
                                        labelPlacement="end"
                                        label="Shop Imported"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={state.apex_auto_app} onChange={handleCheckChange} name="apex_auto_app" disabled={id} />}
                                        labelPlacement="end"
                                        label="Apex Auto"
                                    />
                                </Stack>
                            </FormControl>
                        </Grid>

                        {/* Vehicle field */}
                        <Grid item xs={12}>
                            <FormControl fullWidth error={!!errors.vehicle}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '8px',
                                        marginTop: customerCreatedFrom == 'shop_imported' ? '11px' : '',
                                    }}
                                >
                                    <Typography variant="body1" className="formLabelTitle">
                                        Vehicle <span style={{ color: REQUIRED_RED }}>*</span>
                                    </Typography>

                                    <Stack direction={'row'} alignItems={'center'}>
                                        {vehicleData && getValues().vehicle && (
                                            <>
                                                <Edit color="secondary" sx={{ width: '16px', height: '16px', mr: '6px' }} />

                                                <Typography
                                                    color={'secondary'}
                                                    fontWeight={500}
                                                    fontSize={'15px'}
                                                    onClick={() => {
                                                        // open new VehicleModalV4 in edit mode
                                                        const selected = Array.isArray(vehicleList)
                                                            ? vehicleList.find((v) => v._id === getValues().vehicle)
                                                            : null;
                                                        setEditVehicleData(selected || null);
                                                        setOpenVehicleModal(true);
                                                    }}
                                                    sx={{ cursor: 'pointer' }}
                                                >
                                                    Edit
                                                </Typography>

                                                <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 1, height: '20px' }} />
                                            </>
                                        )}
                                        {customerData && customerData?.createdFrom != 'shop_imported' && (
                                            <>
                                                <Add color="secondary" sx={{ width: '16px', height: '16px', mr: '2px' }} />
                                                <Typography
                                                    color={'secondary'}
                                                    fontWeight={500}
                                                    fontSize={'15px'}
                                                    onClick={() => {
                                                        // handleVehicleInfoOpen();
                                                        // setVehicleSourceData('');
                                                        setEditVehicleData(null);
                                                        handleVehicleOpen();
                                                    }}
                                                    sx={{ cursor: 'pointer' }}
                                                >
                                                    Add
                                                </Typography>
                                            </>
                                        )}
                                    </Stack>
                                </div>

                                <Controller
                                    name="vehicle"
                                    control={control}
                                    rules={{ required: 'Vehicle is required' }}
                                    render={({ field: { onChange, value, name, ref } }) => (
                                        <Autocomplete
                                            open={vehicleDropdownOpen}
                                            onOpen={() => setVehicleDropdownOpen(true)}
                                            onClose={() => setVehicleDropdownOpen(false)}
                                            id="vehicle-select-autocomplete-appointment"
                                            name={name}
                                            ref={ref}
                                            forcePopupIcon
                                            clearIcon={null}
                                            options={vehicleList?.length > 0 ? vehicleList : []}
                                            loading={vehicleLoader}
                                            value={Array.isArray(vehicleList) && customerData ? vehicleList.find((item) => item._id === vehicleData) || '' : ''}
                                            filterOptions={(options, state) => {
                                                const inputValue = state.inputValue.toLowerCase().trim();

                                                // Add this guard — MUI sometimes calls with empty string on open
                                                if (!inputValue) return options;

                                                const searchWords = inputValue.split(' ').filter(Boolean);

                                                return options.filter((option) => {
                                                    const valuesToCheck = [
                                                        option?.vehicleMake?.name,
                                                        option?.vehicleModel?.name,
                                                        option?.vehicleModelTrim?.name,
                                                        option?.vehicleModelTrim?.description,
                                                        option?.vehicleYear?.toString(),
                                                        option?.year?.toString(),
                                                        option?.vin,
                                                        option?.licenseNumber,
                                                        option?.fleetUnitNumber,
                                                        option?.provinceCode,
                                                    ]
                                                        .filter(Boolean)
                                                        .map((v) => v.toLowerCase());

                                                    return searchWords.every((word) => valuesToCheck.some((field) => field.includes(word)));
                                                });
                                            }}
                                            getOptionKey={(option) => option._id}
                                            getOptionLabel={(option) => {
                                                if (!option) return '';
                                                return [
                                                    option.vehicleYear || option.year || '',
                                                    option?.vehicleMake?.name || '',
                                                    option?.vehicleModel?.name || '',
                                                ]
                                                    .filter(Boolean)
                                                    .join(' ');
                                            }}
                                            loadingText={
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <CircularProgress />
                                                </div>
                                            }
                                            onChange={(event, newValue) => {
                                                if (newValue?.source && newValue?.source == 'shop_imported') {
                                                    // setVehicleSourceData(newValue);
                                                    // handleVehicleInfoOpen();
                                                    setEditVehicleData(newValue);
                                                    handleVehicleOpen();
                                                    return;
                                                } else {
                                                    setVehicleData(newValue?._id);
                                                    clearErrors('vehicle');
                                                    onChange(newValue?._id);
                                                }
                                            }}
                                            ListboxProps={{
                                                style: { maxHeight: '300px' },
                                            }}
                                            renderInput={(params) => {
                                                const endAdornment = params.InputProps.endAdornment;
                                                const clearIcon = endAdornment?.props?.children?.[0] || null;
                                                const dropdownIcon = endAdornment?.props?.children?.[1] || null;

                                                return (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                    {clearIcon && (
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                mr: '2px',
                                                                            }}
                                                                        >
                                                                            {clearIcon}
                                                                        </Box>
                                                                    )}
                                                                    {dropdownIcon && <Box sx={{ display: 'flex', alignItems: 'center' }}>{dropdownIcon}</Box>}
                                                                </Box>
                                                            ),
                                                        }}
                                                    />
                                                );
                                            }}
                                            renderOption={(props, option) => {
                                                const vehicleTitle = [
                                                    option.vehicleYear || option.year || '',
                                                    option?.vehicleMake?.name || '',
                                                    option?.vehicleModel?.name || '',
                                                    // option?.vehicleModelTrim?.name || '',
                                                ]
                                                    .filter(Boolean)
                                                    .join(' ');

                                                const trimDetail =
                                                    option?.vehicleModelTrim?.description?.trim() || option?.vehicleModelTrim?.name?.trim() || '';
                                                const showTrimRow = Boolean(trimDetail);
                                                const showVinRow = Boolean(option?.vin);
                                                const showFleetRow = Boolean(option?.fleetUnitNumber);

                                                return (
                                                    <Box
                                                        component="li"
                                                        {...props}
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            gap: 1.5,
                                                            width: '100%',
                                                            maxWidth: '100%',
                                                            overflow: 'hidden',
                                                            py: 1.25,
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                flex: 1,
                                                                minWidth: 0,
                                                                overflow: 'hidden',
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    fontSize: '16px',
                                                                    fontWeight: 500,
                                                                    color: '#212121',
                                                                    lineHeight: '130%',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    lineHeight: '130%',
                                                                }}
                                                            >
                                                                {vehicleTitle}
                                                            </Typography>

                                                            {(showTrimRow || showVinRow || showFleetRow) && (
                                                                <Stack spacing={0.5} sx={{ mt: 0.75 }}>
                                                                    {showTrimRow && (
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '8px',
                                                                                minWidth: 0,
                                                                            }}
                                                                        >
                                                                            <Box sx={{ flexShrink: 0, display: 'flex' }}>
                                                                                <CustomerTrim />
                                                                            </Box>
                                                                            <Typography
                                                                                sx={{
                                                                                    fontSize: '14px',
                                                                                    fontWeight: 400,
                                                                                    color: 'rgba(0, 0, 0, 0.6)',
                                                                                    lineHeight: '143%',
                                                                                    overflow: 'hidden',
                                                                                    letterSpacing: '0.15px',
                                                                                }}
                                                                            >
                                                                                {trimDetail}
                                                                            </Typography>
                                                                        </Box>
                                                                    )}
                                                                    {showVinRow && (
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '8px',
                                                                                minWidth: 0,
                                                                            }}
                                                                        >
                                                                            <Box sx={{ flexShrink: 0, display: 'flex' }}>
                                                                                <CustomerVin />
                                                                            </Box>
                                                                            <Typography
                                                                                sx={{
                                                                                    fontSize: '14px',
                                                                                    fontWeight: 400,
                                                                                    color: 'rgba(0, 0, 0, 0.6)',
                                                                                    lineHeight: '143%',
                                                                                    letterSpacing: '0.15px',
                                                                                }}
                                                                            >
                                                                                {option.vin}
                                                                            </Typography>
                                                                        </Box>
                                                                    )}
                                                                    {showFleetRow && (
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '8px',
                                                                                minWidth: 0,
                                                                            }}
                                                                        >
                                                                            <Box sx={{ flexShrink: 0, display: 'flex' }}>
                                                                                <CustomerFleet />
                                                                            </Box>
                                                                            <Typography
                                                                                sx={{
                                                                                    fontSize: '14px',
                                                                                    fontWeight: 400,
                                                                                    color: 'rgba(0, 0, 0, 0.6)',
                                                                                    lineHeight: '143%',
                                                                                    overflow: 'hidden',
                                                                                    letterSpacing: '0.15px',
                                                                                }}
                                                                            >
                                                                                {option.fleetUnitNumber}
                                                                            </Typography>
                                                                        </Box>
                                                                    )}
                                                                </Stack>
                                                            )}
                                                        </Box>

                                                        {(option.licenseNumber || option.license) && (
                                                            <Box
                                                                sx={{
                                                                    backgroundColor: '#f5f5f5',
                                                                    border: '1px solid #dcdcdc',
                                                                    borderRadius: '6px',
                                                                    padding: '4px 12px',
                                                                    fontSize: '14px',
                                                                    fontWeight: 400,
                                                                    lineHeight: '150%',
                                                                    letterSpacing: '0.15px',
                                                                    color: '#333333',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    flexShrink: 0,
                                                                    alignSelf: 'center',
                                                                    textTransform: 'uppercase',
                                                                }}
                                                            >
                                                                {`${option?.provinceCode ? `${option.provinceCode} ` : ''}${
                                                                    option.licenseNumber || option.license || ''
                                                                }`}
                                                            </Box>
                                                        )}
                                                    </Box>
                                                );
                                            }}
                                            sx={{
                                                height: '50px',
                                                boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                borderRadius: '8px',
                                                '& .MuiInputBase-root': {
                                                    padding: '0 0 0 12px',
                                                    border: 'none',
                                                    height: '50px',
                                                },
                                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                    borderRadius: '8px',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    paddingRight: '6px!important',
                                                },
                                            }}
                                        />
                                    )}
                                />
                                {errors.vehicle && <FormHelperText error>{errors.vehicle.message}</FormHelperText>}
                            </FormControl>
                        </Grid>

                        {/* Drop Off field */}
                        <Grid item xs={12}>
                            <FormControl fullWidth required error={!!errors?.dropOffDate}>
                                <Typography variant="body1" className="formLabelTitle" marginBottom={'8px'}>
                                    Drop Off
                                    <span style={{ color: REQUIRED_RED }}> *</span>
                                </Typography>
                                <Controller
                                    name="dropOffDate"
                                    control={control}
                                    rules={{
                                        required: 'Drop-off date and time are required.',
                                    }}
                                    render={({ field: { onChange, value, name, ref }, fieldState: { error } }) => (
                                        <>
                                            <TextField
                                                name={name}
                                                ref={ref}
                                                fullWidth
                                                value={dropOffDate ? dropOffDate.format('DD-MMM-YYYY - hh:mm A') : ''}
                                                onClick={() => setDropOffPickerOpen(true)}
                                                onFocus={(e) => e.target.blur()}
                                                error={!!error}
                                                placeholder="Select date and time"
                                                InputProps={{
                                                    readOnly: true,
                                                    endAdornment: (
                                                        <IconButton onClick={() => setDropOffPickerOpen(true)} edge="end" sx={{ pr: 1.5 }}>
                                                            <CalendarPickerSvg />
                                                        </IconButton>
                                                    ),
                                                }}
                                                sx={{
                                                    height: '50px',
                                                    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                    borderRadius: '8px',
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                        padding: '12px 12px 12px 0',
                                                        height: '50px',
                                                    },
                                                    '& .MuiOutlinedInput-root': {
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderRadius: '8px',
                                                            borderColor: 'rgba(0, 0, 0, 0.23)',
                                                        },
                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'rgba(0, 0, 0, 0.23)',
                                                            borderWidth: '1px',
                                                        },
                                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'rgba(0, 0, 0, 0.23)',
                                                        },
                                                    },
                                                }}
                                            />
                                            <CustomDateTimePicker
                                                open={dropOffPickerOpen}
                                                onClose={() => setDropOffPickerOpen(false)}
                                                value={dropOffDate || value}
                                                shopId={shopId}
                                                onSaveSuccess={() => {
                                                    // Mark that date picker was used and saved successfully
                                                    if (datePickerWasUsedRef) {
                                                        datePickerWasUsedRef.current = true;
                                                    }
                                                }}
                                                onChange={(data) => {
                                                    let cloneData = data;
                                                    if (!dayjs(cloneData).isValid()) {
                                                        setDropOffDate(data);
                                                        setError('dropOffDate', {
                                                            type: 'custom',
                                                            message: 'Invalid date',
                                                        });
                                                        return;
                                                    }
                                                    // Logic to respect user selected time always
                                                    clearErrors('dropOffDate');
                                                    setDropOffDate(data);
                                                    setValue('pickUpDate', data);
                                                    getShopClosingTime(data);
                                                    onChange(data);

                                                    // We might not need isFirstSelection anymore for this logic,
                                                    // but keeping the state update if it's used elsewhere or just to be safe it doesn't trigger again if logic changes back.
                                                    if (isFirstSelection) {
                                                        setIsFirstSelection(false);
                                                    }

                                                    clearErrors('pickUpDate');
                                                }}
                                                timeSlotInterval={shopConfigData?.shopSlotTimeInMin}
                                            />
                                        </>
                                    )}
                                />
                                {errors?.dropOffDate && (
                                    <FormHelperText error sx={{ marginTop: '4px', marginLeft: '14px' }}>
                                        {errors.dropOffDate.message}
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        {/* Pick Up Time field */}
                        <Grid item xs={12}>
                            <FormControl fullWidth required error={!!errors?.pickUpDate}>
                                <Typography variant="body1" className="formLabelTitle" marginBottom={'8px'}>
                                    Pick Up Time
                                    <span style={{ color: REQUIRED_RED }}> *</span>
                                </Typography>
                                <Controller
                                    name="pickUpDate"
                                    control={control}
                                    rules={{ required: 'Pickup date and time are required.' }}
                                    render={({ field: { onChange, value, name, ref }, fieldState: { error } }) => (
                                        <>
                                            <TextField
                                                name={name}
                                                ref={ref}
                                                fullWidth
                                                value={pickUpDate ? pickUpDate.format('DD-MMM-YYYY - hh:mm A') : ''}
                                                onClick={() => setPickUpPickerOpen(true)}
                                                onFocus={(e) => e.target.blur()}
                                                error={!!error}
                                                placeholder="Select date and time"
                                                InputProps={{
                                                    readOnly: true,
                                                    endAdornment: (
                                                        <IconButton onClick={() => setPickUpPickerOpen(true)} edge="end" sx={{ pr: 1.5 }}>
                                                            <CalendarPickerSvg />
                                                        </IconButton>
                                                    ),
                                                }}
                                                sx={{
                                                    height: '50px',
                                                    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                    borderRadius: '8px',
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                        padding: '12px 12px 12px 0',
                                                        height: '50px',
                                                    },
                                                    '& .MuiOutlinedInput-root': {
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderRadius: '8px',
                                                            borderColor: 'rgba(0, 0, 0, 0.23)',
                                                        },
                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'rgba(0, 0, 0, 0.23)',
                                                            borderWidth: '1px',
                                                        },
                                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'rgba(0, 0, 0, 0.23)',
                                                        },
                                                    },
                                                }}
                                            />
                                            <CustomDateTimePicker
                                                open={pickUpPickerOpen}
                                                onClose={() => setPickUpPickerOpen(false)}
                                                value={pickUpDate || value}
                                                shopId={shopId}
                                                onChange={(data) => {
                                                    onChange(data);
                                                    setPickUpDate(data);
                                                    clearErrors('pickUpDate');
                                                }}
                                                minDate={dropOffDate ? dayjs(dropOffDate).add(1, 'minute') : undefined}
                                                shouldDisableDate={disablePrevDates(dropOffDate)}
                                                timeSlotInterval={shopConfigData?.shopSlotTimeInMin}
                                            />
                                        </>
                                    )}
                                />
                                {errors?.pickUpDate && (
                                    <FormHelperText error sx={{ marginTop: '4px', marginLeft: '14px' }}>
                                        {errors.pickUpDate.message}
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        {/* Assign To (Calendar) field */}
                        <Grid item xs={12}>
                            <FormControl fullWidth required error={!!errors.assignee}>
                                <Typography variant="body1" className="formLabelTitle" marginBottom={'8px'}>
                                    Assign To (Calendar) <span style={{ color: REQUIRED_RED }}>*</span>
                                </Typography>
                                <Controller
                                    name="assignee"
                                    control={control}
                                    rules={{ required: 'Assign To is required' }}
                                    render={({ field: { onChange, value, name, ref } }) => (
                                        <Select
                                            name={name}
                                            ref={ref}
                                            value={value || ''}
                                            onChange={(event) => {
                                                onChange(event.target.value);
                                            }}
                                            displayEmpty
                                            required
                                            sx={MuiSelectWithFocus}
                                        >
                                            {mechanicList &&
                                                mechanicList?.length > 0 &&
                                                mechanicList.map((item) => {
                                                    return (
                                                        <MenuItem key={item?._id} value={item?._id}>
                                                            {item.name}
                                                        </MenuItem>
                                                    );
                                                })}
                                            {mechanicDetailsLoading && (
                                                <MenuItem
                                                    value={null}
                                                    disabled
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <CircularProgress />
                                                </MenuItem>
                                            )}
                                            {!mechanicDetailsLoading && mechanicList.length === 0 && (
                                                <MenuItem value={null} disabled>
                                                    No assignee found
                                                </MenuItem>
                                            )}
                                        </Select>
                                    )}
                                />
                                {errors.assignee && <FormHelperText error>{errors.assignee.message}</FormHelperText>}
                            </FormControl>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};

export default AppointmentDetailsAccordion;
